import paths from '~/constants/paths';

const SET_ADDRESSES = 'set_addresses';
const UPDATE_ADDRESS = 'update_address';
const DELETE_ADDRESS = 'delete_address';

const BASE_ENDPOINT = '/relation/addresses';

const state = () => ({
  addresses: {},
});

const actions = {
  fetchAddresses ({ commit }, filters = {}) {
    return this.$getDataProvider(BASE_ENDPOINT)
      .getList('', filters)
      .then((response) => {
        const addresses = {};
        response.items.forEach((address) => {
          addresses[address.uuid] = address;
        });

        commit(SET_ADDRESSES, addresses);

        return response;
      });
  },

  fetchOne ({ commit }, { uuid }) {
    return this.$getDataProvider(BASE_ENDPOINT)
      .getList('', { uuid })
      .then((response) => {
        commit(UPDATE_ADDRESS, response.data);

        return response;
      });
  },

  createAddress ({ commit, rootState }, addressArg) {
    const address = { ...addressArg };
    const currentCompany = rootState.account.user.currentCompany;

    if (currentCompany !== null) {
      const companiesPath = `${paths.api}${paths.companies}/`;
      address.company = `${companiesPath}${currentCompany}`;
    } else {
      const customersPath = `${paths.api}${paths.customers}/`;
      address.customer = `${customersPath}${rootState.account.user.uuid}`;
    }

    return this.$getDataProvider(BASE_ENDPOINT).create('', {
      data: {
        ...address,
        deliveryAddress: true,
        country: address.country.code || address.country,
      },
    })
      .then((response) => {
        commit(UPDATE_ADDRESS, response.data);

        return response;
      });
  },

  // Todo: Use API endpoint
  // eslint-disable-next-line no-empty-pattern
  autoCompleteBelgiumPostcodeCity ({}, { searchTerm }) {
    return this.$api.get('/data/city-and-postcode', {
      q: searchTerm,
    }, {
      useSiteEndpoint: true,
    }).then((response) => {
      return response.data;
    });
  },

  updateAddress ({ commit }, address) {
    return this.$getDataProvider(BASE_ENDPOINT)
      .update('', {
        data: {
          ...address,
          deliveryAddress: true,
          country: address.country.code || address.country,
        },
        uuid: address.uuid,
      })
      .then((response) => {
        commit(UPDATE_ADDRESS, response.data);

        return response;
      });
  },

  deleteAddress ({ commit }, address) {
    const { uuid } = address;
    if (
      address.isCompanyMainAddress
      || address.isDefaultInvoiceAddress
      || address.isDefaultDeliveryAddress
    ) {
      return Promise.reject(new Error('undeletable'));
    }

    return this.$getDataProvider(BASE_ENDPOINT)
      .delete('', { uuid })
      .then((response) => {
        commit(DELETE_ADDRESS, address);

        return response;
      })
      .catch((error) => error.message);
  },

  // Todo: Check if FormData is required
  // eslint-disable-next-line no-empty-pattern
  suggestAddress ({}, postcodeNumber) {
    const formData = new FormData();
    formData.append('postcode', postcodeNumber.postcode);
    formData.append('number', postcodeNumber.number);

    return this.$api
      .post(paths.postcodeSuggestion, formData)
      .then((response) => response)
      .catch((error) => error);
  },
};

const mutations = {
  [SET_ADDRESSES] (state, addresses) {
    state.addresses = addresses;
  },

  [UPDATE_ADDRESS] (state, address) {
    const addresses = { ...state.addresses };
    addresses[address.uuid] = address;
    state.addresses = addresses;
  },

  [DELETE_ADDRESS] (state, address) {
    const addresses = { ...state.addresses };
    delete addresses[address.uuid];
    state.addresses = addresses;
  },
};

const getters = {
  findByUuid: (state) => (uuid) => {
    return state.addresses[uuid] ?? null;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
